import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// coalesce multiple dom events within the same frame into a single
// change detection run. helps a lot in the questionnaire editor,
// where hundreds of components take part in each cd cycle (MYM-1029)
platformBrowserDynamic().bootstrapModule(AppModule, {ngZoneEventCoalescing: true})
  .catch(err => console.error(err));
